'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

GroupTreeDirective=function(_BaseControllerBacked){_inherits(GroupTreeDirective,_BaseControllerBacked);function GroupTreeDirective(){_classCallCheck(this,GroupTreeDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(GroupTreeDirective,[{key:'objectBindings',get:function()
{
return['groupTree','selectedGroup'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/groupTreeDirective/groupTreeTemplate';
}},{key:'controller',get:function()

{
return GroupTreeDirectiveController;
}}]);return GroupTreeDirective}(BaseControllerBackedDirective);let


GroupTreeDirectiveController=function(){_createClass(GroupTreeDirectiveController,null,[{key:'$inject',get:function()
{
return['groupTreeService','$scope'];
}}]);

function GroupTreeDirectiveController(groupTreeService,$scope){_classCallCheck(this,GroupTreeDirectiveController);
this._groupTreeService=groupTreeService;
this._$scope=$scope;
}GroupTreeDirectiveController.prototype.

expandAll=function expandAll(){var _this2=this;
this._$scope.$evalAsync(function(){
_this2._groupTreeService.expandAllGroups();
});
};GroupTreeDirectiveController.prototype.

collapseAll=function collapseAll(){var _this3=this;
this._$scope.$evalAsync(function(){
_this3._groupTreeService.collapseAllGroups();
});
};_createClass(GroupTreeDirectiveController,[{key:'groupTree',get:function()

{
return this._groupTreeService.groupTree;
},set:function(

groupTree){

}},{key:'selectedGroup',get:function()

{
return this._groupTreeService.selectedGroup;
},set:function(

selectedGroup){
if(!_.exists(selectedGroup)){
return;
}

this._groupTreeService.selectGroupWithId(selectedGroup.id);
}},{key:'expandedGroups',get:function()

{
return this._groupTreeService.expandedGroups;
},set:function(

expandedGroups){
this._groupTreeService.expandedGroups=expandedGroups;
}}]);return GroupTreeDirectiveController}();


module.exports=GroupTreeDirective;
//# sourceMappingURL=groupTreeDirective.js.map
